import React from "react";
import { Modal, InputNumber } from "antd";
import { connect } from "react-redux";
import { compose, withState } from "recompose";
import { withTranslation } from "react-i18next";

import {
  unpublishOpportunity,
  UNPUBLISH_OPPORTUNITY,
  saveOpportunityDetails,
  SAVE_OPPORTUNITY_DETAILS
} from "../../../../store/actions/opportunity";
import { isLoading } from "../../../../utils/actions";
import history from "../../../../history";
import Button from "../../../../components/Button";

import styled from "styled-components/macro";

const Title = styled.h2`
  text-align: center;
  vertical-align: middle;
`;

const SubTitle = styled.h3`
  margin-top: 15px;
  text-align: center;
  vertical-align: middle;
`;

const ContentButton = styled.div`
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
`;

const ContentInput = styled.div`
  margin-top: 15px;
  display: flex;
  justify-content: center;
`;

const ContentTitle = styled.div`
  margin-top: 15px;
  height: 120px;
`;

const FullPosition = ({
  t,
  onClose,
  opportunity,
  unpublishOpportunity,
  loadingUnpublish,
  saveOpportunityDetails,
  savingOpportunity,
  setCount,
  count,
  step,
  setStep
}) => {
  const { id, positions } = opportunity;

  return (
    <Modal
      width="700px"
      visible={true}
      footer={null}
      maskClosable={false}
      closable={false}
      wrapProps={{
        "data-test": "full-position-modal"
      }}
    >
      {step === 0 && (
        <ContentTitle>
          <Title>{t("opportunity:process.fullPosition.congratulations")}</Title>
          <SubTitle>
            {t("opportunity:process.fullPosition.fullPositions")}
          </SubTitle>
        </ContentTitle>
      )}
      {step === 1 && (
        <ContentTitle>
          <Title>{t("opportunity:process.fullPosition.addPosition")}</Title>
          <SubTitle>
            {t("opportunity:process.fullPosition.countPositions")}
          </SubTitle>
          <ContentInput>
            <InputNumber
              data-test="new-positions-input"
              defaultValue={positions + 1}
              min={positions + 1}
              max={50}
              onChange={value => setCount(value)}
            />
          </ContentInput>
        </ContentTitle>
      )}

      <ContentButton>
        {step === 0 && (
          <>
            <Button
              data-test="add-positions-btn"
              type="quaternary"
              disabled={loadingUnpublish}
              onClick={() => setStep(step + 1)}
            >
              {t("opportunity:process.fullPosition.keepOpen")}
            </Button>
            <Button
              data-test="close-opportunity-btn"
              type="primary"
              style={{
                marginLeft: 5
              }}
              loading={loadingUnpublish}
              onClick={async () => {
                await unpublishOpportunity({
                  id,
                  closingReason: "position-filled"
                });
                history.push(`oportunidades/${id}/detalles`);
              }}
            >
              {t("opportunity:process.fullPosition.closeOpportunity")}
            </Button>
          </>
        )}
        {step === 1 && (
          <>
            <Button
              type="quaternary"
              loading={loadingUnpublish}
              disabled={savingOpportunity}
              onClick={async () => {
                await unpublishOpportunity({
                  id,
                  closingReason: "position-filled"
                });
                history.push(`oportunidades/${id}/detalles`);
              }}
            >
              {t("opportunity:process.fullPosition.closeOpportunity")}
            </Button>
            <Button
              data-test="confirm-positions-btn"
              type="primary"
              style={{
                marginLeft: 5
              }}
              loading={savingOpportunity}
              disabled={loadingUnpublish}
              onClick={async () => {
                await saveOpportunityDetails({
                  id,
                  formData: { positions: count }
                });
                onClose();
              }}
            >
              {t("opportunity:process.fullPosition.savePositions")}
            </Button>
          </>
        )}
      </ContentButton>
    </Modal>
  );
};

const enhancer = compose(
  withTranslation(["opportunity"]),
  connect(
    state => ({
      loadingUnpublish: isLoading(UNPUBLISH_OPPORTUNITY, state),
      savingOpportunity: isLoading(SAVE_OPPORTUNITY_DETAILS, state),
      opportunity: state.opportunity.selected
    }),
    {
      unpublishOpportunity,
      saveOpportunityDetails
    }
  ),
  withState("count", "setCount", props => props.opportunity.positions + 1),
  withState("step", "setStep", 0)
);
export default enhancer(FullPosition);
